import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Accordion,
  Spinner,
} from "react-bootstrap";
import config from "../../services/apiConfig";
import { apiPaths } from "../../services/apiPath";
import ChatBox from "../../components/Chatbox/chatbox";
import VendorNavBar from "../VendorApplyEventScreen/Component/VendorNavBar";
import {
  getFromLocalStorage,
  saveToLocalStorage,
  deleteFromLocalStorage,
} from "../../store";
const VendorChatViewScreen = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAcceptedApplications();
  }, []);

  const fetchAcceptedApplications = async () => {
    try {
      const response = await fetch(`${config.BASE_URI}${apiPaths.adminData}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          payload: {
            body: {
              query_type: "get_shared_accepted_vendor_applications",
              operator_id: JSON.parse(getFromLocalStorage("Operator"))[0].id,
            },
          },
        }),
      });

      const result = await response.json();

      if (result.success) {
        setApplications(result.qs_sharable_stalls);
      } else {
        console.error("Failed to fetch applications.");
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <VendorNavBar />
      <Container className="mt-4">
        <h4 className="mb-4 text-center">Accepted Applications with Chat</h4>

        {loading ? (
          <div className="text-center mt-5">
            <Spinner animation="border" />
          </div>
        ) : applications.length === 0 ? (
          <p>No accepted applications found.</p>
        ) : (
          applications.map((item, index) => (
            <Accordion key={index} className="mb-3">
              <Card>
                <Accordion.Toggle as={Card.Header} eventKey="0">
                  <Row>
                    <Col><strong>Vendor:</strong> {item.vendor__title}</Col>
                    <Col><strong>Organiser:</strong> {item.event_organiser_full_name}</Col>
                    <Col><strong>Event:</strong> {item.event_name}</Col>
                  </Row>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <Row><Col><strong>Email:</strong> {item.email}</Col></Row>
                    <Row><Col><strong>Status:</strong> {item.status}</Col></Row>
                    <Row><Col><strong>Page Opened:</strong> {item.amount_of_times_page_opened}</Col></Row>
                    <Row><Col><strong>Last Opened:</strong> {item.last_time_link_was_opened || "Never"}</Col></Row>
                    <Row><Col><strong>Wants to Book:</strong> {item.does_organiser_want_to_book_the_truck ? "Yes" : "No"}</Col></Row>

                    {/* 🔥 Vendor Chat Component */}
                    {item.hash_code && (
                      <div className="mt-3">
                        <h6>Chat with Organiser</h6>
                        <ChatBox hashcode={item.hash_code} userType="vendor" />
                      </div>
                    )}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          ))
        )}
      </Container>
    </>
  );
};

export default VendorChatViewScreen;
